<template>
  <div>
    <a-form layout="inline" :model="formState" style="margin-bottom: 10px">
      <a-form-item label="车型">
        <a-input
          v-model:value="formState.name"
          placeholder="输入检索车型"
          allow-clear
        />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="handelSearch">查询</a-button>
      </a-form-item>
      <a-form-item style="position: absolute; right: 60px" v-if="ableAdd">
        <a-button type="primary" @click="showAddModal">添加车型</a-button>
      </a-form-item>
    </a-form>
    <a-modal
      v-model:open="open"
      :title="isEdit ? '编辑车型' : '添加车型'"
      :footer="null"
      :destroyOnClose="true"
    >
      <add-modal
        :v-if="open"
        @submit="clickOk"
        :isEdit="isEdit"
        :editData="editData"
        :data="tableData"
      ></add-modal>
    </a-modal>
    <a-table
      :columns="columns"
      :row-key="(record) => record.uuid"
      :data-source="tableData"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'need_record'">
          {{ codeToText(record.need_record, ['不需要', '需要']) }}
        </template>
        <template v-if="column.key === 'check_overweight'">
          {{ codeToText(record.check_overweight, ['不需要', '需要']) }}
        </template>
        <template v-if="column.key === 'show_cargo_type'">
          {{ codeToText(record.show_cargo_type, ['不显示', '显示']) }}
        </template>
        <template v-if="column.key === 'need_blind_video'">
          {{ codeToText(record.need_blind_video, ['不需要', '需要']) }}
        </template>
        <template v-if="column.key === 'need_truck_driver_license'">
          {{ codeToText(record.need_truck_driver_license, ['不需要', '需要']) }}
        </template>
        <template v-if="column.key === 'need_trailer_registration'">
          {{ codeToText(record.need_trailer_registration, ['不需要', '需要']) }}
        </template>
        <template v-if="column.key === 'need_truck_compulsory_insurance'">
          {{ codeToText(record.need_truck_compulsory_insurance, ['不需要', '需要']) }}
        </template>
        <template v-if="column.key === 'need_truck_commercial_insurance'">
          {{ codeToText(record.need_truck_commercial_insurance, ['不需要', '需要']) }}
        </template>
        <template v-if="column.key === 'action'">
          <span>
            <a-button @click="showEditModal(record)" v-if="ableEdit">编辑</a-button>
            <a-popconfirm
              title="确认删除？"
              ok-text="确认"
              cancel-text="取消"
              @confirm="delRow(record)"
              v-if="ableDelete"
            >
              <a-button danger>删除</a-button>
            </a-popconfirm>
          </span>
        </template>
      </template>
    </a-table>
  </div>
</template>
<script setup>
  import { ref, reactive, onMounted, computed } from 'vue'
  import { useStore } from 'vuex'
  import { getModal, deleteModal } from '@/api/system_manage/modal'
  import AddModal from './addModal'
  import { message } from 'ant-design-vue'
  import { codeToText } from '@/utils/format'
  const store = useStore()

  const permissionList = computed(() => store.getters['user/permissionList'])
  const ableAdd = computed(() =>
    !!permissionList.value?.find(item => item.code === 'modal:add')
  )
  const ableEdit = computed(() =>
    !!permissionList.value?.find(item => item.code === 'modal:edit')
  )
  const ableDelete = computed(() =>
    !!permissionList.value?.find(item => item.code === 'modal:delete')
  )

  //1、搜索框
  const formState = reactive({
    name: '',
  })
  function handelSearch() {
    pagination.value.current = 1
    fetch()
  }

  //2、表格
  const columns = [
    {
      title: '车型',
      dataIndex: 'name',
      key: 'name',
      align: 'left',
    },
    {
      title: '车速(km/h)',
      dataIndex: 'speed',
      key: 'speed',
      align: 'left',
    },
    {
      title: '预约需要备案',
      dataIndex: 'need_record',
      key: 'need_record',
      align: 'left',
    },
    {
      title: '页面是否显示货物类型',
      dataIndex: 'show_cargo_type',
      key: 'show_cargo_type',
      align: 'left',
    },
    {
      title: '判断超重',
      dataIndex: 'check_overweight',
      key: 'check_overweight',
      align: 'left',
    },
    {
      title: '预约是否需要上传盲区视频监控图片',
      dataIndex: 'need_blind_video',
      key: 'need_blind_video',
      align: 'left',
    },
    {
      title: '预约是否需要上传驾驶证图片',
      dataIndex: 'need_truck_driver_license',
      key: 'need_truck_driver_license',
      align: 'left',
    },
    {
      title: '预约是否需要上传挂车行驶证及挂车图片（含车牌号）',
      dataIndex: 'need_trailer_registration',
      key: 'need_trailer_registration',
      align: 'left',
    },
    {
      title: '预约是否需要上传强制险图片',
      dataIndex: 'need_truck_compulsory_insurance',
      key: 'need_truck_compulsory_insurance',
      align: 'left',
    },
    {
      title: '预约是否需要上传商业险图片',
      dataIndex: 'need_truck_commercial_insurance',
      key: 'need_truck_commercial_insurance',
      align: 'left',
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      align: 'left',
      width: '140px',
    },
  ]

  const tableData = ref([])
  const loading = ref(false)
  const pagination = ref({
    current: 1,
    pageSize: 10,
    showLessItems: true,
    showQuickJumper: true,
    showSizeChanger: true,
    showTotal: (total, range) => {
      return `共 ${total} 条`
    },
  })

  function handleTableChange(page) {
    pagination.value = { ...pagination.value, ...page }
    fetch()
  }

  function fetch() {
    loading.value = true
    getModal({
      size: pagination.value.pageSize,
      pn: pagination.value.current,
      ...formState,
    }).then(({ data }) => {
      loading.value = false
      tableData.value = data.list
      pagination.value.total = data.total
    })
  }
  onMounted(fetch)

  //3、编辑、添加
  const open = ref(false)
  const isEdit = ref(false)
  const editData = ref(null)

  const showAddModal = () => {
    editData.value = null
    isEdit.value = false
    open.value = true
  }
  const showEditModal = (data) => {
    editData.value = data
    isEdit.value = true
    open.value = true
  }

  function clickOk() {
    fetch()
    handleOk()
    clearEditData()
  }

  const handleOk = () => {
    open.value = false
  }
  const clearEditData = () => {
    editData.value = null
  }

  //4、删除
  async function delRow(data) {
    const res = await deleteModal({ id: data.id })
    if (res.success) {
      message.success('删除成功！')
      fetch()
    } else {
      message.warn('删除失败' + res.message)
    }
  }
</script>
